<template>
    <div>
        <v-list
                subheader
                two-line
                text
        >
            <SpecialistItem v-for="item in items"
                            :key="item.id"
                            :canSign="canSign"
                            :readonly="readonly"
                            @onSign="handleOnSign"
                            @onBeforeSign="handleOnBeforeSign"
                            @onDeleteSign="handleOnDeleteSign"
                            :item="item"
                            @delete="handleDeleteSpecialist"/>
        </v-list>
    </div>
</template>

<script>
    import SpecialistItem from './SpecialistItem'

    export default {
        name: 'SpecialistList',
        components: {
            SpecialistItem
        },
        props: {
            items: Array,
            canSign: Boolean,
            readonly: Boolean
        },
        methods: {
            handleDeleteSpecialist(id) {
                this.$emit('delete', id)
            },
            handleOnSign(specialistId) {
                this.$emit('onSign', specialistId)
            },
            handleOnDeleteSign(specialistId) {
                this.$emit('onDeleteSign', specialistId)
            },
            handleOnBeforeSign(next) {
                this.$emit('onBeforeSign', next)
            }
        }
    }
</script>

<style scoped>

</style>